module.exports = __webpack_public_path__ + "static/media/terrace_garden.0eadf2b2.jpg";